import script from "./LastConversations.vue?vue&type=script&setup=true&lang=ts"
export * from "./LastConversations.vue?vue&type=script&setup=true&lang=ts"

export default script